import React, { useEffect, useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import { IconButton, MenuList } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

//Redux
import { useDispatch, useSelector } from "react-redux";
import { addFollowup, getQuestions, deleteQuestion } from '../redux/actions/admin.actions';

//Components
import AddQuestion from './addQuestionModal';



export default function MenuListComposition({vals}) {
  const dispatch = useDispatch();
  const { questions } = useSelector(state => state.data);
  const [open, setOpen] = React.useState(false);
  const [modal, setModal] = useState(false);
  const [values, setValues] = useState({
    action: 'addfu',
    choiceId: []
  });
  let cp = localStorage.getItem('copyQuestion');

  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleClick = (data) => {
    if(data === 'addfu'){
       setValues({ 
           action: data,
           parentQuestionId: vals.id,
            })
       setModal(true);
    }
    if(data === 'eq'){
        setValues({ 
            action: data,
            parentQuestionId: vals.id,
             })
        setModal(true);
     }
     if(data === 'addCfu'){
        setValues({ 
            action: data,
            parentQuestionId: vals.parentId,
            choiceId: [vals.id]
             })
        setModal(true);
     }

     if(data === 'cq'){
        localStorage.setItem("copyQuestion", vals.id);
     }
     if(data === 'dq'){
        dispatch(deleteQuestion(vals.id))
        .then(() => {
          dispatch(getQuestions())
        })
        .catch(err => {
          console.log(err)
        })
     }

    if(data === 'pq'){
      let vl = questions.find(a => a._id === cp);
      vl.choiceId = [vals.id];
      dispatch(addFollowup(vl))
      .then(() => {
        dispatch(getQuestions())
      })
      .catch(err => {
        console.log(err)
      })
     }

     
     setOpen(false);
  }
  return (
      <>
      <AddQuestion modal={modal} handleModal={setModal} vals={values} type={vals.type}/>
        {/* <Button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          Toggle Menu Grow
        </Button> */}
        <IconButton  ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle} 
                   style={{
                  verticalAlign: "middle"
                }}
             >
               <MoreVertIcon color="primary"/>
               </IconButton>
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition 
        // disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  
                      {vals.type === 'question' ? <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <MenuItem onClick={() => handleClick('addfu')}>Add Followup</MenuItem>
                    {/* <MenuItem onClick={() => handleClick('eq')}>Edit Question</MenuItem> */}
                    <MenuItem onClick={() => handleClick('cq')}>Copy Question</MenuItem>
                    <MenuItem onClick={() => handleClick('dq')}>Delete Question</MenuItem></MenuList>
                    :
                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}><MenuItem onClick={() => handleClick('addCfu')}>Add Followup</MenuItem>
                   {cp !== null &&   <MenuItem onClick={() => handleClick('pq')}>Paste Question</MenuItem>}
                     </MenuList>
                }
                  
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
  );
}
